import AnimatedIcon from '../components/AnimatedIcon.jsx';
import AnimatedWrapper from '../components/AnimatedWrapper.jsx';

const studies = [
	{
		title: 'Starbucks Reserve Roasteries',
		icon: 'story',
		summary:
			'Interactive tasting bars with NFC-enabled coasters let guests explore sourcing stories, boosting premium merchandise sales by double digits.',
		alignment:
			'We design scannable artifacts that mirror this curiosity-driven storytelling while integrating your POS and loyalty stack.',
	},
	{
		title: 'Meow Wolf Immersive Exhibits',
		icon: 'immersion',
		summary:
			'Responsive lighting, audio, and projection loops adapt to visitor presence, keeping dwell times high and social buzz constant.',
		alignment:
			'Our creative technologists craft similar adaptive atmospheres for retail, hospitality, and cultural spaces with measurable KPIs.',
	},
	{
		title: 'San Diego Airport Smart Curbside',
		icon: 'airport',
		summary:
			'IoT-enabled signage and queue management tools cut wait times and improved traveler satisfaction scores 24% in pilot runs.',
		alignment:
			'TapptiQ brings responsive signage and analytics to local businesses craving that same smooth, reassuring flow.',
	},
];

const CaseStudies = () => {
	return (
		<div className="page case-studies-page">
			<AnimatedWrapper direction="up" delay={0}>
				<section className="section-heading">
					<p className="eyebrow">Proof in the experiences</p>
					<h1>Case studies inspiring our craft</h1>
					<p>
						From household names to local pioneers, these stories demonstrate how
						artful IoT ecosystems unlock loyalty, efficiency, and cultural
						resonance.
					</p>
				</section>
			</AnimatedWrapper>
			<div className="case-grid">
				{studies.map((study, i) => (
					<AnimatedWrapper key={study.title} direction="up" delay={i * 120}>
						<article className="case-card">
							<span className="case-icon" aria-hidden="true">
								<AnimatedIcon name={study.icon} />
							</span>
							<h2>{study.title}</h2>
							<p>{study.summary}</p>
							<p className="case-alignment">{study.alignment}</p>
						</article>
					</AnimatedWrapper>
				))}
			</div>
			<AnimatedWrapper direction="up" delay={studies.length * 120}>
				<section className="callout">
					<h2>Ready to script your own success story?</h2>
					<p>
						Let&apos;s co-create an installation that feels like tomorrow and
						performs for decades.
					</p>
				</section>
			</AnimatedWrapper>
		</div>
	);
};

export default CaseStudies;
